export default function calculateNumberOfTorahAnytimeWizardRows(width) {
    if (width < 544) {
        return Math.round((window.innerHeight - 100) / 240);
    }
    return Math.round((window.innerHeight - 100) / 240);
}
